import React, { useRef, useState, useEffect } from "react";
import Card from "../UI/Card/Card";
import ReactApexChart from "react-apexcharts";
import Icon from "../UI/Icon/Icon";

import "./Radar.scss";

const debug = false;

export default (props) => {
  const [cardWidth, setCardWidth] = useState(0);
  const chartCardRef = useRef();

  const icons = props.data.icons;
  const scores = props.data.scores;

  debug && console.log("Radar Scores:", props.data);

  const radarData = {
    series: [
      { data: scores},
    ],
    options: {
      chart: {
        toolbar: {
          show: false,
        },
      },
      fill: {
        opacity: 0.5,
        colors: ["#5b82ff"],
      },
      stroke: {
        colors: ["#5b82ff"],
        show: true,
        width: 2,
        dashArray: 0,
      },
      markers: { size: 0 },
      tooltip: { show: false },
      chart: {
        height: 350,
        type: "radar",
      },

      yaxis: { show: false },
      xaxis: {
        labels: { show: false },
        // categories: ["January", "February", "Maxcrch", "April", "May", "June"],
      },
    },
  };

  const cardPadding = 15;
  const iconOffset = 16; //adjust icon distance from center
  const YStretch = 16; //stretch

  useEffect(() => {
    if (chartCardRef.current !== undefined) {
      setCardWidth(chartCardRef.current.offsetWidth);
    }
  }, [chartCardRef]);

  return (
      <Card size="big" cardRef={chartCardRef} style={{padding: cardPadding+YStretch }}>
        {icons.map((icon, i) => {
          /**
           *
           * Draw icons in circle
           *
           * circle formula:
           *     x = a + r cos t
           *     y = b + r sin t
           */

          const a = cardWidth / 2; //X of card's center
          const b = cardWidth / 2; //Y of card's center. same. it's square.
          const r1 = cardWidth / 2 - (cardPadding * 2 - iconOffset); //radius is half of diameter which is card width again
          const r2 = cardWidth / 2 - (cardPadding * 2 - iconOffset - YStretch);

          const adjust_angle = -Math.PI / 2; //rotate back 90 deg to start from highest point of radar
          const rad = (i * 2 * Math.PI) / icons.length + adjust_angle;

          const posX = a + r1 * Math.cos(rad) - cardPadding;
          const posY = b + r2 * Math.sin(rad) + cardPadding + YStretch ;

          const style = { position: "absolute", left: posX, top: posY, zIndex: 1 };

          return (
            <Icon
              image={icon.icon}
              size="l"
              title={icon.score? icon.score: "0"}
              className="Card__icon"
              layout="vertical"
              style={style}
              key={i}
            />
          );
        })}
        <ReactApexChart
          options={radarData.options}
          series={radarData.series}
          type="radar"
          height={cardWidth + cardPadding * 2 + YStretch}
        />
      </Card>
  );
};
